<template>
  <v-dialog
    v-model="dialogProxy"
    width="600"
    scrollable
    persistent
    eager
    @keydown.esc="close"
    @click:outside="close"
  >
    <v-card class="app-card card-borderless">
      <gg-toolbar @close="close">
        Add User
      </gg-toolbar>
      <v-card-text class="pt-2 pb-3">
        <v-row>
          <v-col cols="12">
            Adding a User for "{{ path }}".
          </v-col>
          <v-col cols="12" class="py-0">
            <gg-text-field
              v-model="user"
              label="User"
              v-validate="'required'"
              data-vv-name="uname"
              data-vv-as="User"
              autocomplete="off"
              :error-messages="errors.collect('uname')"
              @keyup.enter="addUser"
            />
          </v-col>
          <v-col cols="12" class="py-0">
            <compact-password
              v-model="password"
              cpanel-app="passwd"
              show-strength
              outlined
              label="Password"
              autocomplete="off"
              v-validate="'required'"
              data-vv-name="password"
              data-vv-as="Password"
              :error-messages="errors.collect('password')"
              with-generator
              @keyup.enter="addUser"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-content-end pb-4 pt-0">
        <gg-btn secondary @click="close">Cancel</gg-btn>
        <gg-btn :loading="loading" @click="addUser">Add User</gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import amapi from '@/api/amapi'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'AddUserModal',
  components: {
    CompactPassword
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true,
      type: Boolean
    },
    path: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      user: '',
      password: ''
    }
  },
  computed: {
    dialogProxy: {
      get () {
        return this.value
      },
      set (val) {
        if (!val) {
          this.$emit('close')
        }
        this.$emit('change', val)
      }
    }
  },
  methods: {
    ...mapActions({
      reportError: 'reportError',
      reportSuccess: 'reportSuccess'
    }),
    async addUser () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      const data = {
        uapi_module: 'DirectoryPrivacy',
        uapi_function: 'add_user',
        dir: this.path,
        user: this.user,
        password: this.password,
        _username: this.$route.query.user,
      }
      this.loading = true
      try {
        await amapi.cpanel_uapi(data)
        this.reportSuccess(`User "${this.user}" successfully added for "${this.path}".`)
        this.$emit('user-added')
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
      this.reset()
      this.close()
    },
    reset () {
      this.user = ''
      this.password = ''
    },
    close () {
      this.dialogProxy = false
    }
  }
}
</script>
